import ScrollMixin from '@/mixins/ScrollMixin'
import SafariMixin from '@/mixins/SafariMixin'
export default {
  name: 'char-2',
  components: {},
  props: [],
  mixins: [ScrollMixin,SafariMixin],
  data () {
    return {
      mainElementId: 'main',
      offseterId: 'offseter',
      numSlides: 4,
      minTitleScroll: 0,
      isFull: false
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    showFull () {
      this.isFull = true
    },
    hideFull () {
      this.$nextTick(() => {
        this.isFull = false
      })
    },
    goBack () {
      this.$router.push({ name: 'home', hash: '#historias' })
    }
  }
}


